import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';
import {
  CATEGORIES,
  FontAwesomeIcon,
} from '@hivebrite/design-system/FontAwesomeIcon';

import { type FieldSuggestion } from 'hb-react/shared/components/AIFormWidget/types';

interface RejectedStateProps {
  onUndo: () => void;
  suggestion: FieldSuggestion;
}

export const RejectedState = ({ suggestion, onUndo }: RejectedStateProps) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="space-between"
    width="100%"
  >
    <Box display="flex" alignItems="center" gridColumnGap={3}>
      <FontAwesomeIcon
        color="fire"
        height="24px"
        iconName="circle-xmark"
        iconType={CATEGORIES.SOLID}
      />
      <Box font="body-semibold-asphalt">
        {s__('AIForm|"%{fieldLabel}" suggestion rejected.').i__({
          fieldLabel: suggestion.schema.label,
        })}
      </Box>
    </Box>
    <Button variant="secondary" size="small" onClick={onUndo}>
      {s__('AIForm|Undo')}
    </Button>
  </Box>
);
